export default {"src":"/_next/static/media/aws.1ce85cb8.svg","height":45,"width":76,"blurWidth":0,"blurHeight":0};